import React from "react";
import ArticleIcon from '@mui/icons-material/Article';
import CampaignIcon from '@mui/icons-material/Campaign';
import ManageHistoryTwoToneIcon from '@mui/icons-material/ManageHistoryTwoTone';
import HomeIcon from "@mui/icons-material/Home";
import WebsiteIcon from "@mui/icons-material/Language";
import StoreIcon from "@mui/icons-material/LocalGroceryStore";
import AccountIcon from "@mui/icons-material/AccountBalance";
import LogoutIcon from "@mui/icons-material/Logout";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { authRouteConstants, dashboardRouteConstants } from "./routeConstants";
// import {
//     authRouteConstants,
//     dashboardRouteConstants,
// } from "constants/routeConstants";

/* ------------------- TOP-RIGHT APPBAR HAMBURGER MENU ------------------- */
export const appbarSidebarMenu = [
    {
        title: "Dashboard",
        key: "dashboard",
        icon: <HomeIcon />,
        subItems: [
            { title: "Order List", key: "order_list", href: dashboardRouteConstants.DASHBOARD_ORDER_LIST },
            { title: "POS", key: "pos", href: dashboardRouteConstants.DASHBOARD_POS },
        ],
    },
    {
        title: "Website Settings",
        key: "website_settings",
        icon: <WebsiteIcon />,
        subItems: [
            { title: "Website templates", key: "web_template", href: dashboardRouteConstants.WEB_TEMPLATE },
            { title: "Domain(s)", key: "domain", href: dashboardRouteConstants.DOMAIN },
            { title: "Contact details", key: "contact", href: dashboardRouteConstants.CONTACT },
            { title: "About", key: "about", href: dashboardRouteConstants.ABOUT },
            { title: "Terms & Conditions", key: "terms", href: dashboardRouteConstants.WEB_TERMS_AND_CONDITION },
            { title: "Returns & Refunds", key: "returns", href: dashboardRouteConstants.PRIVACY_POLICY },
        ],
    },
    {
        title: "Integration",
        key: "integration",
        icon: <ManageHistoryTwoToneIcon />,
        subItems: [
            { title: "Pilot POS", key: "pilot_pos", href: dashboardRouteConstants.PILOTPOS },
            { title: "Payments", key: "payments", href: dashboardRouteConstants.PAYMENTS },
            { title: "Shipping", key: "shipping", href: dashboardRouteConstants.SHIPPING },
        ],
    },
    {
        title: "Account",
        key: "account",
        icon: <AccountIcon />,
        subItems: [
            { title: "Account details", key: "Account Details  ", main: true, href: dashboardRouteConstants.ACC_DETAIL },
            { title: "User Management", key: "subusers", main: true, href: dashboardRouteConstants.SUBUSERS },
            { title: "Subscription", key: "subscription", main: true, href: dashboardRouteConstants.BILLING_DETAIL },
        ],
    },
];

/* ------------------- DESKTOP NAV ------------------- */
export const sideMenuItems = [
    {
        title: "Dashboard",
        key: "dashboard",
        icon: <HomeIcon />,
        main: true,
        child: [
            { title: "Order List", key: "order_list", path: dashboardRouteConstants.DASHBOARD_ORDER_LIST },
            { title: "POS", key: "pos", path: dashboardRouteConstants.DASHBOARD_POS },
        ],
    },
    {
        title: "Website Settings",
        key: "website_settings",
        icon: <WebsiteIcon />,
        child: [
            { title: "Website templates", key: "web_template", path: dashboardRouteConstants.WEB_TEMPLATE },
            { title: "Domain(s)", key: "domain", path: dashboardRouteConstants.DOMAIN },
            { title: "Contact details", key: "contact", path: dashboardRouteConstants.CONTACT },
            { title: "About", key: "about", path: dashboardRouteConstants.ABOUT },
            { title: "Terms & Conditions", key: "terms", path: dashboardRouteConstants.WEB_TERMS_AND_CONDITION },
            { title: "Returns & Refunds", key: "returns", path: dashboardRouteConstants.PRIVACY_POLICY },
        ],
    },
    {
        title: "Store",
        key: "store",
        icon: <StoreIcon />,
        child: [
            { title: "Categories", key: "categories", path: dashboardRouteConstants.CATEGORIES },
            {
                title: "Products", key: "products", path: dashboardRouteConstants.PRODUCTS,
                child: [
                    { title: "Add-on Groups", key: "addon_groups", path: dashboardRouteConstants.ADDON_GROUPS },
                    { title: "Raw Materials", key: "raw_materials", path: dashboardRouteConstants.RAW_MATERIALS },
                    { title: "Components & Resources", key: "recipes", path: dashboardRouteConstants.RECIPES },
                ],
            },
            { title: "Delivery options", key: "delivery", path: dashboardRouteConstants.DELIVERY },
            { title: "Order Management", key: "order_note", path: dashboardRouteConstants.ORDERNOTE },
            { title: "Tips in Payment", key: "tips_in_payment", path: dashboardRouteConstants.TIPSETTINGS },
        ],
    },
    {
        title: "Integration",
        key: "integration",
        icon: <ManageHistoryTwoToneIcon />,
        child: [
            { title: "Pilot Pos", key: "pilot_pos", path: dashboardRouteConstants.PILOTPOS },
            // { title: "Order note", path: dashboardRouteConstants.ORDERNOTE },
            { title: "Payments", key: "payments", path: dashboardRouteConstants.PAYMENTS },
            { title: "Shipping", key: "shipping", path: dashboardRouteConstants.SHIPPING },
        ],
    },
    {
        title: "Marketing",
        key: "marketing",
        icon: <CampaignIcon />,
        child: [
            { title: "Vouchers", key: "vouchers", path: dashboardRouteConstants.VOUCHERS },
            { title: "QR Code", key: "qr_code", path: dashboardRouteConstants.QRCODE },
        ]
    },
    {
        title: "Reports",
        key: "reports",
        icon: <ArticleIcon />,
        child: [

            { title: "Analytics", key: "analytics", path: dashboardRouteConstants.ANALYTICS },
            { title: "Orders", key: "orders", path: dashboardRouteConstants.ORDERS },
            { title: "Sales", key: "sales_report", path: dashboardRouteConstants.SALESREPORT },
            { title: "Monthly Executive", key: "executive_report", path: dashboardRouteConstants.EXECUTIVEREPORT },
            { title: "Inventory", key: "inventory_report", path: dashboardRouteConstants.INVENTORYREPORT },
            { title: "Subuser(s)", key: "subuser_report", path: dashboardRouteConstants.SUBUSERREPORT },
            { title: "Customers", key: "customers", path: dashboardRouteConstants.CUSTOMERS },
        ]
    },
    {
        title: "Account",
        key: "account",
        icon: <AccountIcon />,
        child: [
            { title: "Account details", key: "Account Details  ", path: dashboardRouteConstants.ACC_DETAIL },
            { title: "User Management", key: "subusers", path: dashboardRouteConstants.SUBUSERS },
            { title: "Subscription", key: "subscription", path: dashboardRouteConstants.BILLING_DETAIL },
        ],
    },
    // { title: 'Required Checklist', icon: <InfoIcon />, path: "info" },
    { title: 'Help', key: 'help', main: true, icon: <HelpOutlineIcon />, action: "OPEN_HELP" },
    { title: "Logout", key: "logout", main: true, icon: <LogoutIcon />, path: authRouteConstants.LOGOUT },
];

/* ------------------- BOTTOM NAV (UPDATED) ------------------- */
export const sideMenuItemsBottom = [
    {
        title: "Dashboard",
        key: "dashboard",
        icon: <HomeIcon />,
        main: true,
        child: [
            { title: "Order List", key: "order_list", path: dashboardRouteConstants.DASHBOARD_ORDER_LIST },
            { title: "POS", key: "pos", path: dashboardRouteConstants.DASHBOARD_POS },
        ],
    },
    // {
    //     title: "Website Settings",
    //     key: "website_settings",
    //     icon: <WebsiteIcon />,
    //     child: [
    //         { title: "Website templates", key: "web_template", path: dashboardRouteConstants.WEB_TEMPLATE },
    //         { title: "Domain(s)", key: "domain", path: dashboardRouteConstants.DOMAIN },
    //         { title: "Contact details", key: "contact", path: dashboardRouteConstants.CONTACT },
    //         { title: "About", key: "about", path: dashboardRouteConstants.ABOUT },
    //         { title: "Terms & Conditions", key: "terms", path: dashboardRouteConstants.WEB_TERMS_AND_CONDITION },
    //         { title: "Returns & Refunds", key: "returns", path: dashboardRouteConstants.PRIVACY_POLICY },
    //     ],
    // },
    {
        title: "Store",
        key: "store",
        icon: <StoreIcon />,
        child: [
            { title: "Categories", key: "categories", path: dashboardRouteConstants.CATEGORIES },
            {
                title: "Products", key: "products", path: dashboardRouteConstants.PRODUCTS,
                child: [
                    { title: "Add-on Groups", key: "addon_groups", path: dashboardRouteConstants.ADDON_GROUPS },
                    { title: "Raw Materials", key: "raw_materials", path: dashboardRouteConstants.RAW_MATERIALS },
                    { title: "Components & Resources", key: "recipes", path: dashboardRouteConstants.RECIPES },
                ],
            },
            // { title: "Payments", key: "payments", path: dashboardRouteConstants.PAYMENTS },
            { title: "Delivery options", key: "delivery", path: dashboardRouteConstants.DELIVERY },
            { title: "Order Management", key: "order_note", path: dashboardRouteConstants.ORDERNOTE },
            { title: "Tips in Payment", key: "tips_in_payment", path: dashboardRouteConstants.TIPSETTINGS },
            // { title: "Shipping", key: "shipping", path: dashboardRouteConstants.SHIPPING },
        ],
    },
    {
        title: "Reports",
        key: "reports",
        icon: <ArticleIcon />,
        child: [
            { title: "Analytics", key: "analytics", path: dashboardRouteConstants.ANALYTICS },
            { title: "Orders", key: "orders", path: dashboardRouteConstants.ORDERS },
            { title: "Sales", key: "sales_report", path: dashboardRouteConstants.SALESREPORT },
            { title: "Monthly Executive", key: "executive_report", path: dashboardRouteConstants.EXECUTIVEREPORT },
            { title: "Inventory", key: "inventory_report", path: dashboardRouteConstants.INVENTORYREPORT },
            { title: "Subuser(s)", key: "subuser_report", path: dashboardRouteConstants.SUBUSERREPORT },
            { title: "Customers", key: "customers", path: dashboardRouteConstants.CUSTOMERS },
        ],
    },
    {
        title: "Marketing",
        key: "marketing",
        icon: <CampaignIcon />,
        child: [
            { title: "Vouchers", key: "vouchers", path: dashboardRouteConstants.VOUCHERS },
            { title: "QR Code", key: "qr_code", path: dashboardRouteConstants.QRCODE },
        ],
    },
    {
        title: "Account",
        key: "account",
        icon: <AccountIcon />,
        child: [
            { title: "Account details", key: "account_details", path: dashboardRouteConstants.ACC_DETAIL },
            { title: "User Management", key: "subusers", path: dashboardRouteConstants.SUBUSERS },
            { title: "Subscription", key: "subscription", path: dashboardRouteConstants.BILLING_DETAIL },
        ],
    },
    { title: "Logout", key: "logout", main: true, icon: <LogoutIcon />, path: authRouteConstants.LOGOUT },
];

/* ------------------- DESKTOP NAV (CLIENT) ------------------- */
export const sideMenuItemsforclient = [
    {
        title: "Dashboard",
        key: "dashboard",
        icon: <HomeIcon />,
        main: true,
        child: [
            { title: "Order List", key: "order_list", path: dashboardRouteConstants.DASHBOARD_ORDER_LIST },
            { title: "POS", key: "pos", path: dashboardRouteConstants.DASHBOARD_POS },
        ],
    },
    {
        title: "Website Settings",
        key: "website_settings",
        icon: <WebsiteIcon />,
        child: [
            { title: "Website Customization", key: "web_template", path: dashboardRouteConstants.CUSTOM_WEB_TEMPLATE },
            { title: "Website templates", key: "web_template", path: dashboardRouteConstants.WEB_TEMPLATE },
            { title: "Domain(s)", key: "domain", path: dashboardRouteConstants.DOMAIN },
            { title: "Contact details", key: "contact", path: dashboardRouteConstants.CONTACT },
            { title: "About", key: "about", path: dashboardRouteConstants.ABOUT },
            { title: "Terms & Conditions", key: "terms", path: dashboardRouteConstants.WEB_TERMS_AND_CONDITION },
            { title: "Returns & Refunds", key: "returns", path: dashboardRouteConstants.PRIVACY_POLICY },
        ],
    },
    {
        title: "Store",
        key: "store",
        icon: <StoreIcon />,
        child: [
            { title: "Update Store", key: "update_store", path: dashboardRouteConstants.UpdateStore },
            { title: "Categories", key: "categories", path: dashboardRouteConstants.CATEGORIES },
            { title: "Order Management", key: "order_note", path: dashboardRouteConstants.ORDERNOTE },
            {
                title: "Products", key: "products", path: dashboardRouteConstants.PRODUCTS,
                child: [
                    { title: "Add-on Groups", key: "addon_groups", path: dashboardRouteConstants.ADDON_GROUPS },
                    { title: "Raw Materials", key: "raw_materials", path: dashboardRouteConstants.RAW_MATERIALS },
                    { title: "Components & Resources", key: "recipes", path: dashboardRouteConstants.RECIPES },
                ],
            },
            { title: "Delivery options", key: "delivery", path: dashboardRouteConstants.DELIVERY },
            { title: "Tips in Payment", key: "tips_in_payment", path: dashboardRouteConstants.TIPSETTINGS },
        ],
    },
    {
        title: "Integration",
        key: "integration",
        icon: <StoreIcon />,
        child: [
            { title: "Pilot Pos", key: "pilot_pos", path: dashboardRouteConstants.PILOTPOS },
            { title: "Payments", key: "payments", path: dashboardRouteConstants.PAYMENTS },
            { title: "Shipping", key: "shipping", path: dashboardRouteConstants.SHIPPING },
        ],
    },
    {
        title: "Marketing",
        key: "marketing",
        icon: <CampaignIcon />,
        child: [
            { title: "Vouchers", key: "vouchers", path: dashboardRouteConstants.VOUCHERS },
            { title: "QR Code", key: "qr_code", path: dashboardRouteConstants.QRCODE },
        ]
    },
    {
        title: "Reports",
        key: "reports",
        icon: <ArticleIcon />,
        child: [
            { title: "Analytics", key: "analytics", path: dashboardRouteConstants.ANALYTICS },
            { title: "Orders", key: "orders", path: dashboardRouteConstants.ORDERS },
            { title: "Sales", key: "sales_report", path: dashboardRouteConstants.SALESREPORT },
            { title: "Monthly Executive", key: "executive_report", path: dashboardRouteConstants.EXECUTIVEREPORT },
            { title: "Inventory", key: "inventory_report", path: dashboardRouteConstants.INVENTORYREPORT },
            { title: "Subuser(s)", key: "subuser_report", path: dashboardRouteConstants.SUBUSERREPORT },
            { title: "Customers", key: "customers", path: dashboardRouteConstants.CUSTOMERS },
        ]
    },
    {
        title: "Account",
        key: "account",
        icon: <AccountIcon />,
        child: [
            { title: "Account details", key: "Account Details  ", path: dashboardRouteConstants.ACC_DETAIL },
            { title: "Subscription", key: "subscription", path: dashboardRouteConstants.BILLING_DETAIL },
        ],
    },
    // { title: 'Required Checklist', icon: <InfoIcon />, path: "info" },
    { title: 'Help', key: 'help', main: true, icon: <HelpOutlineIcon />, action: "OPEN_HELP" },
    { title: "Logout", key: "logout", main: true, icon: <LogoutIcon />, path: authRouteConstants.LOGOUT },
];

/* ------------------- BOTTOM NAV (CLIENT, UPDATED) ------------------- */
export const sideMenuItemsforclientBottom = [
    {
        title: "Dashboard",
        key: "dashboard",
        icon: <HomeIcon />,
        main: true,
        child: [
            { title: "Order List", key: "order_list", path: dashboardRouteConstants.DASHBOARD_ORDER_LIST },
            { title: "POS", key: "pos", path: dashboardRouteConstants.DASHBOARD_POS },
        ],
    },
    // {
    //     title: "Website Settings",
    //     key: "website_settings",
    //     icon: <WebsiteIcon />,
    //     child: [
    //         { title: "Website Customization", key: "web_template", path: dashboardRouteConstants.CUSTOM_WEB_TEMPLATE },
    //         { title: "Website templates", key: "web_template", path: dashboardRouteConstants.WEB_TEMPLATE },
    //         { title: "Domain(s)", key: "domain", path: dashboardRouteConstants.DOMAIN },
    //         { title: "Contact details", key: "contact", path: dashboardRouteConstants.CONTACT },
    //         { title: "About", key: "about", path: dashboardRouteConstants.ABOUT },
    //         { title: "Terms & Conditions", key: "terms", path: dashboardRouteConstants.WEB_TERMS_AND_CONDITION },
    //         { title: "Returns & Refunds", key: "returns", path: dashboardRouteConstants.PRIVACY_POLICY },
    //     ],
    // },
    {
        title: "Store",
        key: "store",
        icon: <StoreIcon />,
        child: [
            { title: "Update Store", key: "update_store", path: dashboardRouteConstants.UpdateStore },
            { title: "Categories", key: "categories", path: dashboardRouteConstants.CATEGORIES },
            {
                title: "Products", key: "products", path: dashboardRouteConstants.PRODUCTS,
                child: [
                    { title: "Add-on Groups", key: "addon_groups", path: dashboardRouteConstants.ADDON_GROUPS },
                    { title: "Raw Materials", key: "raw_materials", path: dashboardRouteConstants.RAW_MATERIALS },
                    { title: "Components & Resources", key: "recipes", path: dashboardRouteConstants.RECIPES },
                ],
            },
            { title: "Delivery options", key: "delivery", path: dashboardRouteConstants.DELIVERY },
            { title: "Order Management", key: "order_note", path: dashboardRouteConstants.ORDERNOTE },
            { title: "Tips in Payment", key: "tips_in_payment", path: dashboardRouteConstants.TIPSETTINGS },
        ],
    },
    {
        title: "Reports",
        key: "reports",
        icon: <ArticleIcon />,
        child: [
            { title: "Analytics", key: "analytics", path: dashboardRouteConstants.ANALYTICS },
            { title: "Orders", key: "orders", path: dashboardRouteConstants.ORDERS },
            { title: "Sales", key: "sales_report", path: dashboardRouteConstants.SALESREPORT },
            { title: "Monthly Executive", key: "executive_report", path: dashboardRouteConstants.EXECUTIVEREPORT },
            { title: "Inventory", key: "inventory_report", path: dashboardRouteConstants.INVENTORYREPORT },
            { title: "Subuser(s)", key: "subuser_report", path: dashboardRouteConstants.SUBUSERREPORT },
            { title: "Customers", key: "customers", path: dashboardRouteConstants.CUSTOMERS },
        ],
    },
    {
        title: "Marketing",
        key: "marketing",
        icon: <CampaignIcon />,
        child: [
            { title: "Vouchers", key: "vouchers", path: dashboardRouteConstants.VOUCHERS },
            { title: "QR Code", key: "qr_code", path: dashboardRouteConstants.QRCODE },
        ],
    },
    {
        title: "Account",
        key: "account",
        icon: <AccountIcon />,
        child: [
            { title: "Account details", key: "Account Details  ", path: dashboardRouteConstants.ACC_DETAIL },
            { title: "User Management", key: "subusers", path: dashboardRouteConstants.SUBUSERS },
            { title: "Subscription", key: "subscription", path: dashboardRouteConstants.BILLING_DETAIL },
        ],
    },
    { title: "Logout", key: "logout", main: true, icon: <LogoutIcon />, path: authRouteConstants.LOGOUT },
];

/**
 * Features that require permission checks (from /api/feature endpoint).
 * Only these 25 features need permission — everything else is freely accessible to all users.
 * The key is the menu title, the value is the exact API feature name used for permission lookup.
 */
export const FEATURE_KEY_MAP = {
    // Dashboard group
    "Dashboard": "dashboard",
    "Order List": "order_list",
    "POS": "pos",
    "Store Status": "Store status",
    "Store status": "Store status",
    // Website Settings group
    // Maps API feature_name → menu item key
    "Website Settings": "website_settings",
    "Website templates": "web_template",
    "Domain(s)": "domain",
    "Contact details": "contact",
    "About": "about",
    "Deals": "deals",
    "Terms & Conditions": "terms",
    "Returns & Refunds": "refund",
    "Refund Feature": "refund",
    // Store group
    "Store": "store",
    "Products": "products",
    "Categories": "categories",
    "Ordering Settings": "order_note",
    "Delivery options": "delivery",
    "Tips in Payment": "tips_in_payment",
    "Add-on Groups": "addon_groups",
    "Raw Materials": "raw_materials",
    "Components & Resources": "recipes",
    // Integration group
    "Integration": "integration",
    "Pilot Pos": "pilot_pos",
    "Payments": "payments",
    "Shipping option": "shipping",
    // Marketing group
    "Marketing": "marketing",
    "QR Code": "qr_code",
    "Vouchers": "vouchers",
    // Reports group
    "Reports": "reports",
    "Analytics": "analytics",
    "Orders": "orders",
    "Sales Report": "sales_report",
    "Sales": "sales_report",
    "Inventory Report": "inventory_report",
    "Inventory": "inventory_report",
    "Customers": "customers",
    "Subuser Report": "subuser_report",
    "Subuser(s)": "subuser_report",
    "Executive Report": "executive_report",
    "Monthly Executive": "executive_report",
    // Account group
    "Account": "account",
    "User Management": "subusers",
    "Account details": "Account Details  ",   // used by getFeatureKeyFromPath (menu title)
    "Account Details": "Account Details  ",   // used by buildApiFeaturesFromResponse (API feature_name after trim)
    "Subscription": "subscription",
};

export const CHILD_TO_PARENT_KEY_MAP = {
    "web_template": "website_settings",
    "domain": "website_settings",
    "contact": "website_settings",
    "about": "website_settings",
    "terms": "website_settings",
    "returns": "website_settings",
    "deals": "marketing",
    "categories": "store",
    "products": "store",
    "delivery": "store",
    "order_note": "store",
    "tips_in_payment": "store",
    "pilot_pos": "integration",
    "payments": "integration",
    "shipping": "integration",
    "vouchers": "marketing",
    "qr_code": "marketing",
    "analytics": "reports",
    "orders": "reports",
    "sales_report": "reports",
    "inventory_report": "reports",
    "customers": "reports",
    "subuser_report": "reports",
    "executive_report": "reports",
    "subusers": "account",
    "Account Details  ": "account",
    "Account Details ": "account",
    "Account Details": "account",
    "account details": "account",
    "account_details": "account",
    "subscription": "account",
    "order_list": "dashboard",
    "pos": "dashboard",
    "Store status": "dashboard"
};

/**
 * Finds the API feature name corresponding to a given path.
 * Returns the feature name that matches the backend /api/feature list.
 * If no match is found, returns null (meaning the route is freely accessible).
 * @param {string} path - The current route path.
 * @returns {string|null} - The API feature name or null if not a permission-gated route.
 */
export const getFeatureKeyFromPath = (path) => {
    if (!path) return null;

    // Normalize path: ignore query params and trailing slashes
    const cleanPath = path.split('?')[0].replace(/\/$/, "");

    // Check all potentially relevant menu lists
    const menuLists = [sideMenuItems, sideMenuItemsBottom, sideMenuItemsforclient, sideMenuItemsforclientBottom];

    for (const menu of menuLists) {
        if (!menu) continue;
        for (const item of menu) {
            // Check top-level item
            const itemPath = item.path?.split('?')[0].replace(/\/$/, "");
            if (itemPath === cleanPath) {
                if (item.main) return null; // Freely accessible
                if (item.title in FEATURE_KEY_MAP) return FEATURE_KEY_MAP[item.title];
            }

            // Check children
            if (item.child) {
                for (const child of item.child) {
                    const childPath = child.path?.split('?')[0].replace(/\/$/, "");
                    if (childPath === cleanPath) {
                        console.log("Edit1s", child, item);
                        if (child.main || item.main) return null; // Freely accessible
                        if (child.title in FEATURE_KEY_MAP) return FEATURE_KEY_MAP[child.title];
                        // If child isn't in map, maybe the parent group is gated
                        if (item.title in FEATURE_KEY_MAP) return FEATURE_KEY_MAP[item.title];
                    }

                    // Check grandchildren (e.g. Add-on Groups nested under Products)
                    if (child.child) {
                        for (const grandchild of child.child) {
                            const grandchildPath = grandchild.path?.split('?')[0].replace(/\/$/, "");
                            if (grandchildPath === cleanPath) {
                                if (grandchild.main || child.main || item.main) return null; // Freely accessible
                                if (grandchild.title in FEATURE_KEY_MAP) return FEATURE_KEY_MAP[grandchild.title];
                                // If grandchild isn't in map, fall back to its parent's feature (e.g. Products)
                                if (child.title in FEATURE_KEY_MAP) return FEATURE_KEY_MAP[child.title];
                                if (item.title in FEATURE_KEY_MAP) return FEATURE_KEY_MAP[item.title];
                            }
                        }
                    }
                }
            }
        }
    }

    return null; // Not a permission-gated route
};
